module.exports = __webpack_public_path__ + "img/infrasel_1.5baf1e69.png";